import { useEffect, useState } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Loader } from '@altermaind/web/ui';
import { AlertBadge } from '@/_shared/components/AlertBadge';
import { getDelegatesCall } from '@/organization/state';
import { User } from '@/organization/state/types';
import { AdminHr } from './AdminHr';
import { DelegatesList } from './DelegatesList';

export const DelegatesTab = () => {
  const tShared = useTranslations();
  const [selectedDelegate, setSelectedDelegate] = useState<User | undefined>(undefined);

  const {
    admins,
    hrDelegates,
    execute: executeGetDelegates,
    success: successGetDelegates,
    loading: loadingGetDelegates,
    error: errorGetDelegates,
  } = getDelegatesCall.hook();

  useEffect(() => {
    executeGetDelegates({
      start: 0,
      length: 1000,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loadingGetDelegates) {
    return (
      <Box mt='s' textAlign='center'>
        <Loader size='s' />
      </Box>
    );
  }

  if (errorGetDelegates) {
    const message = tShared('errors.genericApiError');
    return <AlertBadge containerProps={{ mt: 's' }} iconName='info' type='error' label={message} />;
  }

  if (successGetDelegates && !loadingGetDelegates && !errorGetDelegates) {
    return (
      <>
        <AdminHr
          admin={{
            name:
              admins[0]?.firstName && admins[0]?.lastName
                ? `${admins[0]?.firstName} ${admins[0]?.lastName}`
                : '--',
            email: admins[0]?.email || '--',
          }}
        />
        <DelegatesList
          selectedDelegate={selectedDelegate}
          setSelectedDelegate={setSelectedDelegate}
          hrDelegates={hrDelegates}
        />
      </>
    );
  }

  return null;
};
